const API_KEY = process.env.REACT_APP_API_KEY;
const USE_MOCK = false;

export { API_KEY, USE_MOCK };
